const EXPLORER = Object.freeze({
  URL: process.env.VUE_APP_EXPLORER_URL,
  PATH: {
    ACCOUNT: 'account',
    TXS_DETAIL: 'transactions/detail',
  },
});

const HOST = window.location.origin;

const PAYMENT = Object.freeze({
  METHOD_KEY: {
    BANK_TRANSFER: 'bank_transfer',
    CREDIT_CARD: 'credit_card',
  },
  METHODS: JSON.parse(process.env.VUE_APP_PAYMENT_METHODS),
});

const PERMISSION_METHOD = Object.freeze({
  VIEW: 'VIEW',
});

const WALLET_POLL_INTERVAL_MS = 5 * 1000;

export default Object.freeze({
  EXPLORER,
  HOST,
  PAYMENT,
  PERMISSION_METHOD,
  WALLET_POLL_INTERVAL_MS,
});
